import renderConsumablePixel from './consumable';

export default function renderAllPixels(el: HTMLElement) {
  renderConsumablePixel(el);
};

